import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "../../core/translation.core";
import { useQuery } from "@tanstack/react-query";
import ErrorCenterIcon from "../../icons/exclamationTriangleCenter.icon";
import LoadingOvalCenterIcon from "../../icons/loadingOvalCenter.icon";
import { selectCss } from "../reuseables/native.comp";
import localeCore from "../../core/locale.core";
import giftCardCore from "../../core/giftCard.core";
import { GiftCardDefFormData } from "../../types/giftCard";
import { LabelAndSelect, OptionItem } from "../reuseables/form.comp";

interface GiftCardTypeSelectorProps {
  methods: UseFormReturn<GiftCardDefFormData, any>;
}
export default function GiftCardTypeSelector({ methods }: GiftCardTypeSelectorProps) {
  const { t, msg } = useTranslation();

  const {
    data: giftCardTypes,
    isLoading,
    error,
    isError,
  } = useQuery({
    queryKey: ["giftCardTypes"],
    queryFn: () => giftCardCore.listTypes(),
  });

  if (isError) return <ErrorCenterIcon reason={error.message} />;
  if (isLoading) return <LoadingOvalCenterIcon />;

  const options: OptionItem[] = giftCardTypes!.map((p) => ({
    label: localeCore.getLocaleValueDefaultFallback(p.name),
    value: p.id,
  }));

  return (
    <div id="recycle-products-list">
      <LabelAndSelect
        methods={methods}
        label={t(msg.giftCard.giftCardType)}
        fieldName="giftCardTypeId"
        options={options}
        // selectCss={`${selectCss} w-full max-w-64 h-[40px]`}
        topLabelCss="block"
      />
    </div>
  );
}
